import {
    createSlice,
    createAsyncThunk,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import * as API from '../utils/api'
import axios from '../utils/axios'

const holidayAdapter = createEntityAdapter()

const initalState = holidayAdapter.getInitialState({
    status: 'idle',
    error: null
})

export const fetchHoliday = createAsyncThunk(
    'holiday/fetchHoliday',
    async (args, {rejectWithValue}) => {
        return await axios.get(API.HOLIDAY_API)
            .then(response => response.data)
            .catch((error) => {
                return rejectWithValue(error.response.data)
            })
    }
)

const holidaySlice = createSlice({
    name: 'holidays',
    initialState: initalState,
    reducers:{

    },
    extraReducers: {
        [fetchHoliday.pending]: (state, action) => {
            state.status = 'loading'
        },
        [fetchHoliday.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            holidayAdapter.upsertMany(state, action.payload)
        },
        [fetchHoliday.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.payload
        }
    }
})

export default holidaySlice.reducer

export const {
    selectAll: selectHolidays,
} = holidayAdapter.getSelectors((state) => state.holiday)

